import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component TextIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <TextIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <TextIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const TextIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      data-testid="TextIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        d="m2.656 19.296 1.353-3.999h5.64l1.353 4h2.43L8.09 4.5H5.61L.267 19.296zm6.408-5.844h-4.47L6.798 6.96h.062zm8.89 6.029c1.416 0 2.78-.759 3.405-1.959h.051v1.774h2.123v-7.434c0-2.163-1.672-3.548-4.286-3.548-2.666 0-4.328 1.436-4.45 3.384h2.091c.195-.964.995-1.579 2.277-1.579 1.353 0 2.163.718 2.163 1.918v.83l-2.953.174c-2.563.144-4.01 1.303-4.01 3.19 0 1.938 1.477 3.25 3.59 3.25m.616-1.754c-1.19 0-1.969-.615-1.969-1.558 0-.923.749-1.507 2.071-1.6l2.656-.164v.851c0 1.405-1.21 2.471-2.758 2.471"
        clipRule="evenodd"
      />
    </svg>
  )
);
TextIcon.displayName = "TextIcon";
export default TextIcon;
